setTimeout(function() { beautyValidation(); }, 2000);
function beautyValidation(){
  console.log("------beauty product-------")
    if (cookie('countryCode') == "TR" ){
      var addtocartBtn = document.getElementsByClassName('beauty');
      console.log("addtocartBtn", addtocartBtn)
      console.log("addtocartBtn.length", addtocartBtn.length)
      if(addtocartBtn != null){
        for (var i = 0; i < addtocartBtn.length; i++){
          var btnAddCart = addtocartBtn[i]
          btnAddCart.setAttribute("style", "display:none!important;")
         
        }
      }
    }

}